import {
	ApplicationConfig,
	importProvidersFrom,
	provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import {
	PUBLIC_API_URL,
	EXPERIENCE_API_URL,
	EXPERIENCE_ANONYM_API_URL,
	EXTERNAL_API_URL,
	EXTERNAL_SHARE_API_URL,
	USER_MANAGEMENT_API_URL,
	ORG_MANAGEMENT_API_URL,
	USER_INFO_API_URL,
	TAG_MANAGEMENT_API_URL,
	FILE_SHARE_API_URL,
} from '@meta-press/shared-plugins';
import { environment } from '../../environments/environment';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes, withHashLocation()),
		provideAnimations(),

		provideHttpClient(withInterceptors([authInterceptor])),

		// // Use the DataServiceProvider as the implementation of DataService
		// { provide: DataService, useExisting: DataServiceProvider },

		// Provide API URL for shared services
		{ provide: PUBLIC_API_URL, useValue: environment.apiUrl },

		// Provide additional API URLs for services
		{ provide: EXPERIENCE_API_URL, useValue: environment.ExperienceApiUrl },
		{
			provide: EXPERIENCE_ANONYM_API_URL,
			useValue: environment.ExperienceAnonymApi,
		},
		{ provide: EXTERNAL_API_URL, useValue: environment.ExternalApiUrl },
		{
			provide: EXTERNAL_SHARE_API_URL,
			useValue: environment.ExternalShareApiUrl,
		},
		{
			provide: USER_MANAGEMENT_API_URL,
			useValue: environment.UserManagementApiUrl,
		},
		{
			provide: ORG_MANAGEMENT_API_URL,
			useValue: environment.OrgManagementApiUrl,
		},
		{ provide: USER_INFO_API_URL, useValue: environment.userInfoApiUrl },
		{
			provide: TAG_MANAGEMENT_API_URL,
			useValue: environment.TagManagementApiUrl,
		},
		{ provide: FILE_SHARE_API_URL, useValue: environment.FileShareApiUrl },
	],
};
